import { useState, useRef } from "react";

/**
 * Components
 */
import Menu from "components/Menu.jsx";

function Header() {
    const [screen, setScreen] = useState(window.innerWidth);
    const [menuActif, setMenuActif] = useState(true);
    const menuMobileRef = useRef(null)
    const menuBtnRef = useRef(null)

    /**
     * Espionne la largeur d'écran.
     */
    window.addEventListener("resize", () => {
        setScreen(window.innerWidth);
    })
    
    /**
     * Affiche ou cache le menu en mode mobile.
     * @param {Object} e 
     */
    function handleActifMenu(e) {
        menuMobileRef.current.classList.toggle("header-mobile-menu-active");
        menuBtnRef.current.classList.toggle("header-mobile-icon-active");
        menuMobileRef.current.style.transition = "all 500ms ease-in-out";

        setMenuActif(!menuActif);

        if (menuActif === true) {
            menuBtnRef.current.style.position = "fixed";
            menuBtnRef.current.style.right = "10%";
        }
        
        setTimeout(() => {
            menuMobileRef.current.style.transition = "initial";
        }, 500);
    }


    if (screen <= 525) {
        return (
            <header className="header-mobile">
                <div ref={menuMobileRef} className="header-mobile-menu">
                    <Menu />

                    <ul>
                        <li>
                            <a href="mailto:vapephone.boutique@gmail.com">vapephone.boutique@gmail.com</a>
                        </li>
                        <li>
                            <a href="tel:+33695490655">06 95 49 06 55</a>
                        </li>
                    </ul>
    
                    <ul className="header-mobile-menu-social">
                        <li>
                            <a href="https://www.facebook.com/profile.php?id=100091649427261" target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-facebook"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/vapephone_orthez/" target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="header-mobile-bottom">
                    <div>
                        <h1 className="header-mobile-bottom__logo">Vape<span>&</span>Phone</h1>
                        <p>Réparation et vente de téléphone et Cigarettes éléctroniques.</p>
                    </div>
                </div>

                <div ref={menuBtnRef} onClick={() => handleActifMenu()} className="header-mobile-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </header>
        )
    } else {
        return (
            <header className="header">
                <div className="header-top">
                    <ul>
                        <li>
                            <a href="mailto:vapephone.boutique@gmail.com">vapephone.boutique@gmail.com</a>
                        </li>
                        <li>
                            <a href="tel:+33695490655">06 95 49 06 55</a>
                        </li>
                    </ul>
    
                    <ul>
                        <li>
                            <a href="https://www.facebook.com/profile.php?id=100091649427261" target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-facebook"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/vapephone_orthez/" target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </li>
                    </ul>
                </div>
    
                <div className="header-bottom">
                    <div>
                        <h1>Vape<span>&</span>Phone</h1>

                        <p>Réparation et vente de téléphone et Cigarettes éléctroniques.</p>
                    </div>
    
                    <Menu />
                </div>
            </header>
        )
    }

}

export default Header;
